import { StaticDatePicker as StaticDatePickerComp, StaticDatePickerProps } from '@mui/x-date-pickers';
import dayjs from 'lib/dayjs';

export interface StaticDatePickerCompProp<TInputDate, TDate> extends StaticDatePickerProps<TInputDate, TDate> {}

export const StaticDatePicker = <TInputDate, TDate = TInputDate>(props: StaticDatePickerCompProp<TInputDate, TDate> & React.RefAttributes<HTMLDivElement>) => {
  return <StaticDatePickerComp {...props} value={(dayjs().utcOffset() === 0 ? dayjs(props.value).utcOffset(0) : dayjs(props.value)) as TInputDate} />;
};
